import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationBG from './locales/bg/translation.json';
import translationEN from './locales/en/translation.json';
import translationES from './locales/es/translation.json'; // Added Spanish translation

// the translations
const resources = {
    bg: { translation: translationBG },
    en: { translation: translationEN },
    es: { translation: translationES },
};

// Get language from localStorage or use fallback
const savedLanguage = localStorage.getItem('userLanguage');

i18n.use(initReactI18next) // Passes i18n down to react-i18next
    .init({
        resources,
        lng: savedLanguage || 'bg', // Use saved language or fallback to 'bg'
        fallbackLng: 'bg', // fallback language
        interpolation: {
            escapeValue: false, // React already handles escaping
        },
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'],
        },
    });

export default i18n;
